
import React, { useRef,useState,useEffect} from 'react'

import "./saveProject.scss"
import DashboardHeader from '../../components/dashboardheader/DashboardHeader'
import { useOutletContext,useLocation, Navigate, useNavigate } from "react-router-dom";
import CollapsibleHeader from '../../components/collapsibleheader/CollapsibleHeader';
import MultiValueInput from '../../components/communicationinput/MultiValueInput';
import encryptedapiRequest from '../../lib/encryptedapiRequest';
import Comp_ClientContactTypes from '../../components/datacontrols/controlClientContactType';
import Comp_Colonies from '../../components/datacontrols/controlColony';
import apiRequest from '../../lib/apiRequest';
import { setPendingContact } from '../../lib/contactReturnStore';
import CancelButton from '../../components/buttons/cancelbutton/CancelButton';


export default function SaveProject() {
    const { toggleMenu } = useOutletContext();
    const location=useLocation();
    const mode = location.state?.mode;  
    const project=location.state?.project;

    const navigate=useNavigate();

  

    const clientcontact=location.state?.clientcontact;
    const clientContactId=location.state?.clientcontactid;
    const clientid=location.state?.clientid;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});



    // mode= 0 means edit
    // mode= 1 means new project


    console.log("mode",mode);
    console.log("project",project) ;

    // console.log("intitial clientcontact",clientcontact);
    // console.log("intitial clientid",clientid);

    










  // if (loading) return <p>Loading Project data...</p>;
  // if (error) return <p style={{ color: "red" }}>{error}</p>;
  // if (!formData) return <p>Loading form...</p>; // Prevents errors if formData is null




    return (
    <>
    <div className="SaveProjectPage">
        <div className="PageHeader">
          <DashboardHeader title={mode===1?"New Project":"Save Project"} toggleMenu={toggleMenu} />
        </div>

        <div className="pageContent">

              


        </div>


        <div className="buttonContainer">

          <button > Save</button>
          <CancelButton></CancelButton>

        </div>


    </div>

    </>
  )
}
